"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormComboBoxContext", {
    enumerable: true,
    get: function() {
        return FormComboBoxContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormComboBoxContext = /*#__PURE__*/ _react.default.createContext({
    highlighted: 0,
    setHighlighted: ()=>undefined,
    focused: false,
    setFocused: ()=>undefined,
    setSelected: ()=>undefined,
    clearValue: ()=>undefined,
    items: [],
    inputProps: {
        onKeyDown: ()=>undefined,
        onFocus: ()=>undefined,
        onChange: ()=>undefined,
        value: "",
        role: "combobox"
    },
    itemRefs: []
});

//# sourceMappingURL=FormComboBoxContext.js.map